module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"placeholder":"მაგ. თავის ტკივილი","loadingText":"იტვირთება","noOptionsText":"დაიწყეთ აკრეფა","next":"განაგრძე","rotate":"შემოტრიალება"},"en":{"placeholder":"e.g headache","loadingText":"Loading","noOptionsText":"Start Typing","next":"Next","rotate":"Flip"}}')
  delete Component.options._Ctor
}
